import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../hooks/redux'

function ProtectedRoute({ element: Component, ...props }: any) {
  const { isLoggedIn } = useAppSelector((state) => state.auth)
  return <>{isLoggedIn ? <Component {...props} /> : <Navigate to='/' replace />}</>
}

export default ProtectedRoute
